import { Pipe, PipeTransform } from "@angular/core";

/**
 * Pipe utilizado para converter um array em uma string.
 */
@Pipe({
    name: "arrayToString"
})
export class ArrayToStringPipe implements PipeTransform {

    transform(input: string[], shouldBreakLine = false): string {
        if (Array.isArray(input) && input.length > 0) {
            return shouldBreakLine ? input.join("<br>") : input.join(", ");
        }

        return "";
    }
}
